import $ from 'jquery';
import { CartDrawerIO } from './io';
import { formatMoney } from '../core/shopify/format-money';
const slides = document.querySelectorAll('.HomepageCarousel-slide');
const container = $('#js-cart-drawer');
const rawIo = container.find('script[type="application/json"]').first().text() || '{}';
const { moneyFormat  } = CartDrawerIO.create(JSON.parse(rawIo));
// Update ARIA attributes on swatches based on their active state
const updateSwatchAriaAttributes = (slide)=>{
    const allSwatches = slide.querySelectorAll('.js-coll-swatch');
    allSwatches.forEach((elem)=>{
        if (elem instanceof HTMLElement) {
            // Type guard
            if (elem.classList.contains('active')) {
                elem.setAttribute('aria-checked', 'true');
            } else {
                elem.setAttribute('aria-checked', 'false');
            }
        }
    });
};
const updateSlide = async function updateSlide(e, slide) {
    const targetSwatch = e.target;
    if (targetSwatch instanceof HTMLElement) {
        const allSwatches = slide.querySelectorAll('.js-coll-swatch');
        //const HPCar = document.querySelector('.HomepageCarousel') as HTMLElement
        if (targetSwatch.hasAttribute('js-color-swatches') && !targetSwatch.classList.contains('active')) {
            allSwatches.forEach((elem)=>{
                elem.setAttribute('aria-checked', 'false');
                elem.classList.remove('active');
            });
            targetSwatch.setAttribute('aria-checked', 'true');
            targetSwatch.classList.add('active');
            targetSwatch.focus();
            const productUrl = targetSwatch.getAttribute('prod-url');
            if (productUrl) {
                await fetch(productUrl + '.js').then((res)=>res.json()).then((data)=>{
                    /*  initQuickview(data)
          if (HPCar) {
            const div = document.createElement('div')
            div.classList.add('QuickView-overlay')
            div.setAttribute('product-handle', data.handle)
            HPCar.insertBefore(div, HPCar.firstChild)
          }*/ const productName = data.title;
                    const productPrice = data.price;
                    const productImg = data.images[2] || data.images[1] || data.images[0] || data.featured_image;
                    const productHandle = data.handle;
                    const imageElem = slide.querySelector('.HomepageCarousel-image');
                    const priceElem = slide.querySelector('.HomepageCarousel-price');
                    const nameElem = slide.querySelector('.HomepageCarousel-title');
                    const quickviewElem = slide.querySelector('.HomepageCarousel-btn');
                    const wrapperLink = slide.querySelector('.HomepageCarousel-wrapperLink');
                    if (imageElem && imageElem instanceof HTMLElement) {
                        imageElem.style.backgroundImage = `url(${productImg})`;
                    }
                    if (priceElem && priceElem instanceof HTMLElement) {
                        priceElem.innerText = formatMoney(productPrice, moneyFormat || '{{amount}}');
                    }
                    if (wrapperLink && wrapperLink instanceof HTMLElement) {
                        wrapperLink.setAttribute('href', productUrl);
                        // Update aria-label with the product name
                        wrapperLink.setAttribute('aria-label', `View ${productName}`);
                    }
                    if (nameElem && nameElem instanceof HTMLElement) {
                        nameElem.innerHTML = `<a href="${productUrl}">${productName}</a>`;
                    }
                    if (quickviewElem) {
                        quickviewElem.setAttribute('car-handle', productHandle);
                    }
                });
            }
        }
    }
};
export const init = async function() {
    slides.forEach((elem)=>{
        if (elem instanceof HTMLElement) {
            // Update ARIA attributes on page load
            updateSwatchAriaAttributes(elem);
            const colorlist = elem.querySelector('.HomepageCarousel-swatchesLine');
            if (colorlist) {
                colorlist.addEventListener('click', (e)=>updateSlide(e, elem), false);
            }
        }
    });
    // Handle keyboard interactions for accessibility
    document.querySelectorAll('[role="radio"]').forEach((radio)=>{
        if (radio instanceof HTMLElement) {
            // Type guard
            radio.addEventListener('keydown', (e)=>{
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    radio.click();
                }
            });
        }
    });
    slides.forEach((elem)=>{
        if (elem instanceof HTMLElement) {
            const swatches = elem.querySelectorAll('[js-color-swatches]');
            swatches.forEach((swatch)=>{
                if (swatch instanceof HTMLElement) {
                    swatch.addEventListener('focus', ()=>{
                        elem.classList.add('slide-focused');
                    });
                    swatch.addEventListener('blur', ()=>{
                        elem.classList.remove('slide-focused');
                    });
                }
            });
        }
    });
    // Update ARIA attributes when swatches become visible
    $('.HomepageCarousel-swatchesLine').on('mouseenter', function() {
        slides.forEach((elem)=>{
            if (elem instanceof HTMLElement) {
                updateSwatchAriaAttributes(elem);
            }
        });
    });
};
